<template>
    <div v-if="!(minimal && userStatus.type === 'success')">
        <el-tag v-if="!userStatus.description"
                :type="userStatus.type" 
                size="mini">
            {{ userStatus.label }}
        </el-tag>
    
        <el-tooltip v-else
                    :content="userStatus.description">
            <el-tag :type="userStatus.type" 
                    size="mini">
                {{ userStatus.label }}
            </el-tag>
        </el-tooltip>
    </div>
</template>

<script>
import { getStatus } from '@/models/users';

export default {
  name: 'UserStatus',

  props: {
    user: { type: Object, default: () => ({}) },
    minimal: { type: Boolean, default: false }
  },

  computed: {
    userStatus() {
      return getStatus(this.user) || {}
    }
  }
}
</script>